import { RuntimeConfig } from "@pnp/common";
import { AdalClient } from "@pnp/adaljsclient";
export function setup(config) {
    RuntimeConfig.assign(config);
}
var GraphRuntimeConfigImpl = /** @class */ (function () {
    function GraphRuntimeConfigImpl() {
    }
    Object.defineProperty(GraphRuntimeConfigImpl.prototype, "headers", {
        get: function () {
            var graphPart = RuntimeConfig.get("graph");
            if (graphPart !== undefined && graphPart !== null && graphPart.headers !== undefined) {
                return graphPart.headers;
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GraphRuntimeConfigImpl.prototype, "fetchClientFactory", {
        get: function () {
            var graphPart = RuntimeConfig.get("graph");
            // use a configured factory firt
            if (graphPart !== undefined && graphPart !== null && graphPart.fetchClientFactory !== undefined) {
                return graphPart.fetchClientFactory;
            }
            // then try and use spfx context if available
            if (RuntimeConfig.spfxContext !== undefined) {
                return function () { return AdalClient.fromSPFxContext(RuntimeConfig.spfxContext); };
            }
            throw Error("There is no Graph Client available, either set one using configuraiton or provide a valid SPFx Context using setup.");
        },
        enumerable: false,
        configurable: true
    });
    return GraphRuntimeConfigImpl;
}());
export { GraphRuntimeConfigImpl };
export var GraphRuntimeConfig = new GraphRuntimeConfigImpl();
//# sourceMappingURL=graphlibconfig.js.map